import type { GetFeedbackSettingsResponse } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetFeedbackSettingsOptions = { listingId: string };

const getFeedbackSettings = async ({
  listingId,
}: GetFeedbackSettingsOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/feedback_settings`,
    method: 'get',
  };

  const { data } = await axios.request<GetFeedbackSettingsResponse>(config);

  return data;
};

export default getFeedbackSettings;
